import React from 'react';
import styles from './css/ConfirmationPopup.module.css'; // CSS module for styling

function ConfirmationPopup({ message, onConfirm, onCancel }) {
    return (
        <div className={styles.popupBackground}>
            <div className={styles.popupContainer}>
                <p>{message}</p>
                <div className={styles.buttonContainer}>
                    <button onClick={onConfirm} className={styles.confirmButton}>Confirm</button>
                    <button onClick={onCancel} className={styles.cancelButton}>Cancel</button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmationPopup;
